import React from "react";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import Ionicons from "react-native-vector-icons/Ionicons";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import CheckIn from "./src/app/screens/CheckIn";
import Home from "./src/app/screens/Home";
import CheckinRecords from "./src/app/screens/CheckinRecords";
import Contact from "./src/app/screens/Contact";
import {UserContextProvider} from "./src/app/contexts/UserContext";

const HomeStack = createStackNavigator();
const HomeStackScreen = () => (
  <HomeStack.Navigator>
    <HomeStack.Screen
      name="Home"
      component={Home}
      options={{
        headerStyle: {
          backgroundColor: "#75cfb8",
        },
        headerTitleStyle: {
          color: "white",
          fontFamily: "Avenir",
          fontSize: 24,
        },
      }}
    />
    <HomeStack.Screen
      name="Check-in Records"
      component={CheckinRecords}
      options={{
        headerStyle: {
          backgroundColor: "#75cfb8",
        },
        headerTitleStyle: {
          color: "white",
          fontFamily: "Avenir",
          fontSize: 24,
        },
      }}
    />
    <HomeStack.Screen
      name="Emergency Contact"
      component={Contact}
      options={{
        headerStyle: {
          backgroundColor: "#75cfb8",
        },
        headerTitleStyle: {
          color: "white",
          fontFamily: "Avenir",
          fontSize: 24,
        },
      }}
    />
  </HomeStack.Navigator>
);

const CheckinStack = createStackNavigator();
const CheckinStackScreen = () => (
  <CheckinStack.Navigator>
    <CheckinStack.Screen
      name="Quick Check-in"
      component={CheckIn}
      options={{
        headerStyle: {
          backgroundColor: "#75cfb8",
        },
        headerTitleStyle: {
          color: "white",
          fontFamily: "Avenir",
          fontSize: 24,
        },
      }}
    />
  </CheckinStack.Navigator>
);

const Tab = createBottomTabNavigator();

const App = () => {
  return (
    <UserContextProvider>
      <NavigationContainer>
        <Tab.Navigator
          screenOptions={({ route }) => ({
            tabBarIcon: ({ focused, color, size }) => {
              let iconName;

              if (route.name === "Home") {
                iconName = focused ? "home" : "home-outline";
              } else if (route.name === "CheckIn") {
                iconName = focused
                  ? "chatbox-ellipses"
                  : "chatbox-ellipses-outline";
              }

              // You can return any component that you like here!
              return <Ionicons name={iconName} size={size} color={color} />;
            },
          })}
          tabBarOptions={{
            activeTintColor: "#75cfb8",
            inactiveTintColor: "gray",
          }}
        >
          <Tab.Screen
            name="Home"
            component={HomeStackScreen}
            options={{
              title: "Home",
            }}
          />
          <Tab.Screen
            name="CheckIn"
            component={CheckinStackScreen}
            options={{
              title: "Quick Check-In",
            }}
          />
        </Tab.Navigator>
      </NavigationContainer>
    </UserContextProvider>
  );
};

export default App;
